<div>
    <!-- <button (click)="start()">Start Recording</button>
    <button (click)="stop()">Stop Recording</button> -->
    <!-- <p *ngIf="isRecording">Recording in progress...</p> -->
</div>